import fetch from './fetch'

class CommonApi {
	public getPartnerAndCompany(companyId = '') {
		return fetch({
			url: 'injury/resource/partnerAndCompany',
			params: {
				companyId,
			},
		})
	}
}

export default new CommonApi()
